import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_DROPDOWN_ANSWER = gql`
  mutation answerDropDownList(
    $questionResponseDropDownListId: Int!
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $contentPageId: Int!
  ) {
    questionAnswer {
      setAnswer(
        answerDropDownList: {
          questionResponseDropDownListId: $questionResponseDropDownListId
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          contentPageId: $contentPageId
        }
      ) {
        id
      }
    }
  }
`;

const createDropdownAnswer = ({
  questionResponseDropDownListId,
  contentSnippetQuestionId,
  status,
  contentPageId,
  // userFlowStepId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_DROPDOWN_ANSWER}>
    {(AnswerSL, { loading, error, data }) => {
      const variables = {
        questionResponseDropDownListId,
        contentSnippetQuestionId,
        status,
        contentPageId,
        // userFlowStepId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.questionAnswer.setAnswer);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={AnswerSL}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createDropdownAnswer.propTypes = {
  contentPageId: PropTypes.number.isRequired,
  contentSnippetQuestionId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  questionResponseDropDownListId: PropTypes.number.isRequired,
  status: PropTypes.string,
  // userFlowStepId: PropTypes.number,
};

createDropdownAnswer.defaultProps = {
  status: 'NO_RESPONSE',
  // userFlowStepId: 1,
};

export default createDropdownAnswer;
